import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    await new Promise((r) => setTimeout(r, 500));
    const result = login(email.trim(), password);
    if (result.success) {
      navigate("/admin");
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div style={s.page}>
      <div style={s.grid} />
      <div style={s.container}>
        <div style={s.lockWrap}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#a855f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>

        <p style={s.label}>Admin Panel</p>
        <h1 style={s.title}>Restricted Access</h1>
        <p style={s.sub}>Sign in to manage your dashboard</p>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.fieldWrap}>
            <label style={s.fieldLabel}>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              required
              style={s.input}
              onFocus={(e) => (e.target.style.borderColor = "#a855f7")}
              onBlur={(e) => (e.target.style.borderColor = "#1f1f2e")}
            />
          </div>

          <div style={s.fieldWrap}>
            <label style={s.fieldLabel}>Password</label>
            <div style={s.passwordWrap}>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••••"
                required
                style={{ ...s.input, paddingRight: "48px", margin: 0 }}
                onFocus={(e) => (e.target.style.borderColor = "#a855f7")}
                onBlur={(e) => (e.target.style.borderColor = "#1f1f2e")}
              />
              <button type="button" onClick={() => setShowPassword((v) => !v)} style={s.eyeBtn} tabIndex={-1}>
                {showPassword ? (
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {error && (
            <div style={s.errorBox}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#f87171" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <span>{error}</span>
            </div>
          )}

          <button type="submit" disabled={loading} style={s.btn}>
            {loading ? <span style={s.spinner} /> : <><span>Access Dashboard</span><span style={{ marginLeft: "8px" }}>→</span></>}
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  page: {
    background: "#0a0a0f",
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Inter, sans-serif",
    color: "#fff",
    position: "relative",
    overflow: "hidden",
  },
  grid: {
    position: "absolute",
    inset: 0,
    backgroundImage: "linear-gradient(#1f1f2e 1px, transparent 1px), linear-gradient(90deg, #1f1f2e 1px, transparent 1px)",
    backgroundSize: "40px 40px",
    opacity: 0.4,
    pointerEvents: "none",
  },
  container: {
    background: "#0f0f1a",
    border: "1px solid #1f1f2e",
    borderRadius: "20px",
    padding: "48px 40px",
    width: "100%",
    maxWidth: "420px",
    position: "relative",
    zIndex: 1,
    boxShadow: "0 24px 80px rgba(168,85,247,0.08)",
  },
  lockWrap: {
    width: "52px",
    height: "52px",
    borderRadius: "14px",
    background: "rgba(168,85,247,0.1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
  },
  label: { fontSize: "11px", color: "#a855f7", textTransform: "uppercase", letterSpacing: "3px", margin: "0 0 8px" },
  title: { fontSize: "26px", fontWeight: 800, margin: "0 0 6px", color: "#fff" },
  sub: { fontSize: "14px", color: "#6b7280", margin: "0 0 32px" },
  form: { display: "flex", flexDirection: "column", gap: "20px" },
  fieldWrap: { display: "flex", flexDirection: "column", gap: "8px" },
  fieldLabel: { fontSize: "13px", color: "#9ca3af", fontWeight: 500 },
  input: {
    background: "#0a0a0f",
    border: "1px solid #1f1f2e",
    borderRadius: "10px",
    padding: "12px 16px",
    fontSize: "14px",
    color: "#fff",
    outline: "none",
    transition: "border-color 0.2s",
    width: "100%",
    boxSizing: "border-box",
  },
  passwordWrap: { position: "relative", display: "flex", alignItems: "center" },
  eyeBtn: { position: "absolute", right: "12px", background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex", alignItems: "center" },
  errorBox: {
    display: "flex", alignItems: "center", gap: "8px",
    background: "rgba(248,113,113,0.08)", border: "1px solid rgba(248,113,113,0.2)",
    borderRadius: "8px", padding: "10px 14px", fontSize: "13px", color: "#f87171",
  },
  btn: {
    background: "linear-gradient(135deg, #7c3aed, #a855f7)",
    border: "none", borderRadius: "10px", padding: "14px",
    fontSize: "15px", fontWeight: 700, color: "#fff", cursor: "pointer",
    display: "flex", alignItems: "center", justifyContent: "center",
    marginTop: "4px", transition: "opacity 0.2s",
  },
  spinner: {
    width: "18px", height: "18px",
    border: "2px solid rgba(255,255,255,0.3)", borderTop: "2px solid #fff",
    borderRadius: "50%", animation: "spin 0.6s linear infinite", display: "inline-block",
  },
};